export default __webpack_public_path__ + "static/media/success_frame.84bb3f82.png";